export enum AppType {
  chatGpc = "chat-gpc",
  askGpc = "ask-gpc",
}
